// services/notifications.js
import { get, put } from './api';

export const fetchNotifications = async (vendeurId) => {
  const res = await get(`/notifications/${vendeurId}`);
  return res.data;
};

export const marquerNotificationsCommeLues = async (vendeurId) => {
  await put(`/notifications/marquer-lues/${vendeurId}`);
};
